export default __webpack_public_path__ + "static/media/se.f9da2d5f.svg";